/**
 * @generated SignedSource<<91f7fd6e790d409803874cc909db6263>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Redeem_metadata$data = {
  readonly collections: ReadonlyArray<{
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"CollectionMedia_collection">;
  }>;
  readonly " $fragmentType": "Redeem_metadata";
};
export type Redeem_metadata$key = {
  readonly " $data"?: Redeem_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"Redeem_metadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Redeem_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionType",
      "kind": "LinkedField",
      "name": "collections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CollectionMedia_collection"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};

(node as any).hash = "fadfff2dd52ab33fff5047a19803b64f";

export default node;
